<body>
  <div class="table-header">
    <!-- header texts -->
    <app-operations-header
      [header]="CONSTS.HEADER"
      [subHeader]="CONSTS.SUBHEADER"
    ></app-operations-header>

    <!-- header summary table -->
    <app-summary-dashboard
      [summaryData$]="summaryData$"
    ></app-summary-dashboard>
  </div>

  <!-- header urls -->
  <ion-row>
    <ion-col>
      <app-form-date-picker
        [minDate]="minDate"
        [maxDate]="maxDate"
        [ngModel]="date"
        width="180"
        (valueChange)="dateChanged($event)"
      ></app-form-date-picker>
    </ion-col>
    <!-- Icons -->
    <ion-col class="top-icons ion-no-padding">
      <app-table-add-route
        (addRouteEvent)="sendAddRouteSignal($event)"
      ></app-table-add-route>
      @if (fileUploadAllowed) {
        <ion-button
          fill="clear"
          class="upload-btn"
          (click)="fileUpload()"
          onkeypress="fileUpload()"
        >
          <ion-icon
            class="upload-icon"
            src="assets/solid_upload_file.svg"
          ></ion-icon>
          <span class="btn-text">{{ CONSTS.UPLOAD }}</span>
        </ion-button>
      }
      <app-excel-icon
        (exportExcelEvent)="sendExportExcelSignal()"
      ></app-excel-icon>
    </ion-col>
  </ion-row>
  <ion-row>
    <app-summary
      [summaryData$]="summaryData$"
      [exportExcelEvent]="exportExcelEvent"
      [addRouteEvent]="addRouteEvent"
      [selectedDate]="selectedDate"
    ></app-summary>
  </ion-row>
</body>
